/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .style-1 form-input-viewer{padding-bottom:0}[_nghost-%COMP%]     .style-1 form-input-viewer .mat-form-field{padding-bottom:0}[_nghost-%COMP%]     .style-1 form-input-viewer:not(:first-child){border-left:1px solid #cdcdcd;padding-left:10px}[_nghost-%COMP%]   .mat-icon[_ngcontent-%COMP%]{vertical-align:middle}[_nghost-%COMP%]   .info-icon[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
